import { render, staticRenderFns } from "./PublicationsBySourceAndGsmBody.vue?vue&type=template&id=33c30596&"
import script from "./PublicationsBySourceAndGsmBody.vue?vue&type=script&lang=js&"
export * from "./PublicationsBySourceAndGsmBody.vue?vue&type=script&lang=js&"
import style0 from "./PublicationsBySourceAndGsmBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports